// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/_is-array.js
// module id = 124
// module chunks = 31